import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

function ProtectedRoute() {
    const { t } = useTranslation('common');
    const { authInitializing, isAuthenticated } = useAuth();
    const location = useLocation();

    if (authInitializing) {
        return <Spin fullscreen size="large" tip={t('loading.session')} />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    return (
        <div className="app-shell">
            <Outlet />
        </div>
    );
}

export default ProtectedRoute;
